// ============================================================
// ArunaSalesPro - Global Site JavaScript
// Dimuat di SETIAP halaman via _Layout.cshtml.
//
// Modul opsional (load via @section Scripts per halaman):
//   cf-datatable.js  — CF.dataTable + openRowMenu + closeRowMenu
//   cf-filter.js     — openFilterModal + closeFilterModal + updateFilterUI
//   cf-modal.js      — CF.modal + CF.confirm
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // CF.appConfig — client-side store
    // Populated by calling CF.appConfig.load(meResponse)
    // after a successful auth/me API call.
    // ????????????????????????????????????????????????????????
    CF.appConfig = {
        localization: {
            dateFormat:       'dd/MM/yyyy',
            dateTimeFormat:   'dd/MM/yyyy HH:mm',
            timezone:         'Asia/Jakarta',
            currencyCode:     'IDR',
            currencySymbol:   'Rp',
            currencyPosition: 'Prefix',
            decimalDigits:    2,
            decimalSeparator: ',',
            groupSeparator:   '.'
        },
        pagination: {
            defaultPageSize: 10,            
            pageSizeOptions: [10, 25, 50, 100]
        },
        load: function (meResponse) {
            if (meResponse && meResponse.localization) {
                CF.appConfig.localization = meResponse.localization;
            }
            if (meResponse && meResponse.pagination) {
                CF.appConfig.pagination = meResponse.pagination;
            }
        }
    };

    // ────────────────────────────────────────────────────────
    // CF.datetime — tampilkan waktu pada zona Setting ›
    // Localization › Timezone, bukan zona browser.
    //
    // API mengirim UTC ber-akhiran 'Z'; tanpa timeZone eksplisit,
    // toLocale* memakai zona perangkat pemakai — laptop yang disetel
    // zona lain akan menampilkan jam berbeda untuk data yang sama.
    // ────────────────────────────────────────────────────────
    CF.datetime = {
        zone: function () {
            return (CF.appConfig.localization && CF.appConfig.localization.timezone)
                || 'Asia/Jakarta';
        },

        /** Objek Date dari nilai API; null bila kosong/tak terbaca. */
        parse: function (value) {
            if (!value) return null;
            var d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        },

        _fmt: function (value, opts, fallback) {
            var d = CF.datetime.parse(value);
            if (!d) return fallback === undefined ? '—' : fallback;
            opts = $.extend({ timeZone: CF.datetime.zone() }, opts);
            return d.toLocaleString('id-ID', opts);
        },

        /** Jam:menit, mis. "16:15". */
        time: function (value, fallback) {
            return CF.datetime._fmt(
                value, { hour: '2-digit', minute: '2-digit' }, fallback);
        },

        /** Tanggal saja, mis. "27 Agu 2026". */
        date: function (value, fallback) {
            return CF.datetime._fmt(
                value, { day: '2-digit', month: 'short', year: 'numeric' }, fallback);
        },

        /** Tanggal + jam, mis. "27 Agu 2026 16:15". */
        dateTime: function (value, fallback) {
            return CF.datetime._fmt(
                value,
                { day: '2-digit', month: 'short', year: 'numeric',
                  hour: '2-digit', minute: '2-digit' },
                fallback);
        }
    };

    // ????????????????????????????????????????????????????????
    // Generic Dropdown (notif, user) — dipakai di _Header.cshtml
    // ????????????????????????????????????????????????????????
    window.toggleDropdown = function (id) {
        var el  = document.getElementById(id);
        var was = el.classList.contains('show');
        document.querySelectorAll('.dropdown').forEach(function (d) { d.classList.remove('show'); });
        if (!was) el.classList.add('show');
    };

    // ????????????????????????????????????????????????????????
    // Popup Menus (Actions, Columns, dll) — dipakai hampir semua halaman
    // ????????????????????????????????????????????????????????
    window.togglePopup = function (id) {
        var popup = document.getElementById(id);
        if (popup.classList.contains('open')) {
            popup.classList.remove('open');
            return;
        }
        document.querySelectorAll('.popup-menu.open').forEach(function (p) { p.classList.remove('open'); });
        popup.classList.add('open');
    };

    // ????????????????????????????????????????????????????????
    // Global Click + Keyboard Handler
    // Menutup: dropdown, popup, flyout, row-ctx-menu, filter modal
    // ????????????????????????????????????????????????????????
    document.addEventListener('click', function (e) {
        if (!e.target.closest('[onclick*="toggleDropdown"]') && !e.target.closest('.dropdown')) {
            document.querySelectorAll('.dropdown').forEach(function (d) { d.classList.remove('show'); });
        }
        if (!e.target.closest('[onclick*="togglePopup"]') && !e.target.closest('.popup-menu')) {
            document.querySelectorAll('.popup-menu.open').forEach(function (p) { p.classList.remove('open'); });
        }
        if (!e.target.closest('#nav-flyout') && !e.target.closest('.nav-parent-btn')) {
            if (typeof hideFlyout === 'function') hideFlyout();
        }
        if (!e.target.closest('#row-ctx-menu') && !e.target.closest('.kebab-btn')) {
            if (typeof window.closeRowMenu === 'function') window.closeRowMenu();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.dropdown').forEach(function (d) { d.classList.remove('show'); });
            document.querySelectorAll('.popup-menu.open').forEach(function (p) { p.classList.remove('open'); });
            if (typeof window.closeRowMenu     === 'function') window.closeRowMenu();
            if (typeof window.closeFilterModal === 'function') window.closeFilterModal();
        }
    });

    // ????????????????????????????????????????????????????????
    // Skeleton -> Content Reveal — dipakai hampir semua halaman
    // ????????????????????????????????????????????????????????
    window.revealContent = function (delay) {
        delay = delay || 1800;
        setTimeout(function () {
            var sk = document.getElementById('skeleton-view');
            var cv = document.getElementById('content-view');
            if (!sk || !cv) return;
            sk.style.opacity = '0';
            setTimeout(function () {
                sk.style.display = 'none';
                cv.style.display = 'block';
                requestAnimationFrame(function () {
                    cv.style.opacity = '1';
                    if (typeof onContentReady === 'function') onContentReady();
                });
            }, 400);
        }, delay);
    };

    // ????????????????????????????????????????????????????????
    // CF.toast — dipakai di _Layout.cshtml (TempData) & semua halaman
    // ????????????????????????????????????????????????????????
    CF.toast = (function () {
        var ICONS = {
            success: 'fa-solid fa-circle-check',
            error:   'fa-solid fa-circle-xmark',
            warning: 'fa-solid fa-triangle-exclamation',
            info:    'fa-solid fa-circle-info'
        };
        var TITLES      = { success: 'Success', error: 'Error', warning: 'Warning', info: 'Info' };
        var MAX_VISIBLE = 5;
        var DURATION    = 4000;

        function getContainer() {
            var c = document.getElementById('cfToastContainer');
            if (!c) {
                c = document.createElement('div');
                c.id = 'cfToastContainer';
                c.className = 'cf-toast-container';
                document.body.appendChild(c);
            }
            return c;
        }

        function show(type, message, title) {
            var container = getContainer();
            var el = document.createElement('div');
            el.className = 'cf-toast cf-toast-' + type;
            el.innerHTML =
                '<div class="cf-toast-icon"><i class="' + ICONS[type] + '"></i></div>' +
                '<div class="cf-toast-body">' +
                    '<div class="cf-toast-title">' + (title || TITLES[type]) + '</div>' +
                    '<div class="cf-toast-message">' + message + '</div>' +
                '</div>' +
                '<button class="cf-toast-close">&times;</button>' +
                '<div class="cf-toast-progress"></div>';

            el.querySelector('.cf-toast-close').onclick = function () { remove(el); };
            container.prepend(el);
            setTimeout(function () { remove(el); }, DURATION);

            while (container.children.length > MAX_VISIBLE) {
                container.removeChild(container.lastChild);
            }
        }

        function remove(el) {
            el.style.opacity    = '0';
            el.style.transform  = 'translateX(100%)';
            el.style.transition = 'all 0.3s ease';
            setTimeout(function () { el.remove(); }, 300);
        }

        return {
            success: function (msg, title) { show('success', msg, title); },
            error:   function (msg, title) { show('error',   msg, title); },
            warning: function (msg, title) { show('warning', msg, title); },
            info:    function (msg, title) { show('info',    msg, title); }
        };
    })();

})();
